import {
  Size2Dum5ayuyhhau7 as Size2D,
  Companion_getInstance1j5nd3fbu9uao as Companion_getInstance,
} from './korlibs-math-vector-root-korlibs-math-vector.mjs';
import {
  Colors_getInstance2cnv7p5d6jz4u as Colors_getInstance,
  Direction_ONCE_FORWARD_getInstance3k0ums5clxkab as Direction_ONCE_FORWARD_getInstance,
} from './korlibs-image-root-korlibs-image.mjs';
import {
  AppConfig_getInstance1f4nxms5l1ldq as AppConfig_getInstance,
  GameStateManager_getInstance1fpt9jruxa4c2 as GameStateManager_getInstance,
  EntityConfig1odzalh8twrio as EntityConfig,
  EntityFactory_getInstancep4a2f1ep043g as EntityFactory_getInstance,
  createAndConfigureEntity2ecw769f7mzc1 as createAndConfigureEntity,
  Companion_getInstance8hth28t0k7pa as Companion_getInstance_0,
  ScreenCoordinatesTag_getInstance1lh3lt6foghi4 as ScreenCoordinatesTag_getInstance,
  MotionComponent3lz37123ywot7 as MotionComponent,
  SpawnerComponentd0wzbt1zedb2 as SpawnerComponent,
  SpriteComponent2140p6pfvjw8n as SpriteComponent,
  RgbaComponent41z7yfk527ta as RgbaComponent,
  RenderLayerTag_MAIN_EFFECTS_getInstance1f27yxfigi0h6 as RenderLayerTag_MAIN_EFFECTS_getInstance,
  PositionComponentscvaqlhnjb16 as PositionComponent,
  MainCameraConfigg07380lg3ml5 as MainCameraConfig,
  RenderLayerTag_BG_LEVELMAP_getInstance195ziw5gjkqu0 as RenderLayerTag_BG_LEVELMAP_getInstance,
  LevelMapRenderSystem3bjvd6084qpb9 as LevelMapRenderSystem,
  RenderLayerTag_BG_PARALLAX_getInstance8ulikrnambqi as RenderLayerTag_BG_PARALLAX_getInstance,
  ParallaxRenderSystem1rwzodtr9we9f as ParallaxRenderSystem,
  RenderLayerTag_MAIN_LEVELMAP_getInstance3glsvtee6zxl8 as RenderLayerTag_MAIN_LEVELMAP_getInstance,
  RenderLayerTag_MAIN_SPRITES_getInstance1lj095pfo57zh as RenderLayerTag_MAIN_SPRITES_getInstance,
  ObjectRenderSystemrd9rm545jqct as ObjectRenderSystem,
  FastSpriteRenderSystem1k9sase7ue9hi as FastSpriteRenderSystem,
  RenderLayerTag_MAIN_FOREGROUND_getInstance3o9xszxyu9hbm as RenderLayerTag_MAIN_FOREGROUND_getInstance,
  RenderLayerTag_FG_LEVELMAP_getInstance2rsr38glvclvm as RenderLayerTag_FG_LEVELMAP_getInstance,
  RenderLayerTag_FG_PARALLAX_getInstancelt42tzynu7ll as RenderLayerTag_FG_PARALLAX_getInstance,
  RenderLayerTag_FG_DIALOGS_getInstance3ort1eibhniyl as RenderLayerTag_FG_DIALOGS_getInstance,
  RenderLayerTag_DEBUG_getInstanceifd6twswramv as RenderLayerTag_DEBUG_getInstance,
  DebugRenderSystem1qi9g8v19vpbn as DebugRenderSystem,
  TouchInputSystemms13khz9uiv8 as TouchInputSystem,
  SpawnerSystem3ioo3mvn45zad as SpawnerSystem,
  EventSystem2tgxno94diwbi as EventSystem,
  setupTweenEngineSystemsc1anv2j1mxaa as setupTweenEngineSystems,
  LifeCycleSystem35by66p9u1fxf as LifeCycleSystem,
  ParallaxSystemd4t1w9mv91sj as ParallaxSystem,
  PositionSystem29e3c8tkzjlgc as PositionSystem,
  SpriteLayersSystem3dtz0gln12159 as SpriteLayersSystem,
  EntityLinkSystem193xnv7pgyuoh as EntityLinkSystem,
  SpriteSystemypw20c7q75b8 as SpriteSystem,
  SoundSystem3ludlxmbypqlt as SoundSystem,
  CameraSystemweu4j27n4fgl as CameraSystem,
  CloneableData2v7u5lweslfj0 as CloneableData,
  SnapshotSerializerSystem1ir98idbxkus2 as SnapshotSerializerSystem,
  Companion_getInstance1aim057llt5i9 as Companion_getInstance_1,
} from './korge-fleks-hello-world-korge-fleks.mjs';
import {
  VOID7hggqo3abtya as VOID,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  Unit_instanceat14thlj150z as Unit_instance,
  suspendOrReturn49pspzlx5djv as suspendOrReturn,
  numberToInt1ygmcfwhs2fkq as numberToInt,
  println2shhhgwwt4c61 as println,
  getKClass1s3j9wy1cofik as getKClass,
  DurationUnit_SECONDS_getInstance162tnxlnf2fpv as DurationUnit_SECONDS_getInstance,
  toDuration28gf6ughsr3vf as toDuration,
  getKClassFromExpression3vpejubogshaw as getKClassFromExpression,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  KClass1cc9rfeybg8hs as KClass,
  isInterface3d6p8outrmvmk as isInterface,
  toString1pkumu07cwy4m as toString,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  get_EmptyContinuationn1rwa6yr6j5w as get_EmptyContinuation,
  startCoroutineUninterceptedOrReturnGeneratorVersion1r5yf56916wr4 as startCoroutineUninterceptedOrReturnGeneratorVersion,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  protoOf180f3jzyo7rfj as protoOf,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  createThis2j2avj17cvnv2 as createThis,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  fillArrayVali8eppxapiek4 as fillArrayVal,
  numberRangeToNumber25vse2rgp6rs8 as numberRangeToNumber,
  Default_getInstancegttbt9h1yt0q as Default_getInstance,
  random3bgrvtipfs9sh as random,
  throwUninitializedPropertyAccessExceptionyynx7gkm73wd as throwUninitializedPropertyAccessException,
  Companion_getInstance148flmv2wtrla as Companion_getInstance_2,
  toDuration7gy6v749ektt as toDuration_0,
  KProperty1ca4yb4wlo496 as KProperty1,
  getPropertyCallableRef1ajb9in178r5r as getPropertyCallableRef,
} from './kotlin-kotlin-stdlib.mjs';
import {
  Korge3fi4cwjkh8up9 as Korge,
  get_AlphaTransition23l7sd982osvm as get_AlphaTransition,
  withEasingtnol1eyyo9sf as withEasing,
  views116j359zi8nvf as views,
  findFirstAscendante8nli1jx4t64 as findFirstAscendant,
  FixedSizeContainersre0rworj71w as FixedSizeContainer,
  SceneContainer99ijjqni12hp as SceneContainer,
  addTo25e29vq105prw as addTo,
  Companion_getInstance2b4rje0hs8ulh as Companion_getInstance_3,
  Stage1ggtrzujnnkl0 as Stage,
  addUpdater1la23qj9g2d42 as addUpdater,
  get_mouse1jstwhfaumelj as get_mouse,
  Scenezu810y12qpqp as Scene,
  Container7486fjmip554 as Container,
  ImageDataView3md3142sq0hvk as ImageDataView,
  alignRightToLeftOfl5ccxmwoj565 as alignRightToLeftOf,
  get_keysmipauarvwdlb as get_keys,
  addFixedUpdaterkdt88bj87xku as addFixedUpdater,
} from './korge-root-korge.mjs';
import {
  get_milliseconds20vru1dkca6bq as get_milliseconds,
  get_secondsjblpw5qd4dzj as get_seconds,
} from './korlibs-time-root-korlibs-time-core.mjs';
import {
  SerializersModuleBuilderfxsfdohcdipc as SerializersModuleBuilder,
  PolymorphicModuleBuilder1c33fhfru2id5 as PolymorphicModuleBuilder,
  PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor,
  UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException,
  StringSerializer_getInstance100dxy5jlaaom as StringSerializer_getInstance,
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
  throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException,
} from './kotlinx-serialization-kotlinx-serialization-core.mjs';
import { Companion_getInstance3gvjtadf9ot2d as Companion_getInstance_4 } from './korlibs-math-core-root-korlibs-math-core.mjs';
import { get_EASE_IN_OUT_QUAD21w3u6e1aoexb as get_EASE_IN_OUT_QUAD } from './korlibs-math-root-korlibs-math.mjs';
import { Resources1ysf2j4wd5yk7 as Resources } from './korlibs-io-root-korlibs-io.mjs';
import { Level_INFO_getInstance3huxkjtm54h8u as Level_INFO_getInstance } from './korlibs-logger-root-korlibs-logger.mjs';
import {
  ComponentTypexyjrw68h3mkw as ComponentType,
  ComponentsHolder3q340rvi7bl8z as ComponentsHolder,
  configureWorld2tcaoe751ploa as configureWorld,
  Component2zk71ruxtvbyc as Component,
  UniqueId1lkie4p3b7cfv as UniqueId,
  FleksNoSuchSystemException2ayar60lwtokj as FleksNoSuchSystemException,
  IteratingSystem3a6t5fwjqjqys as IteratingSystem,
  Companion_instance30dlkjl07rtbp as Companion_instance,
  EachFrame_instance3v9fuozm77djs as EachFrame_instance,
} from './korge-fleks-hello-world-fleks.mjs';
import {
  Key_P_getInstance1l15tff0scujt as Key_P_getInstance,
  Key_F1_getInstance2uvuzswotma1m as Key_F1_getInstance,
  Key_F2_getInstance1jn8oxhxnia83 as Key_F2_getInstance,
  Key_F3_getInstance3auitqeii852j as Key_F3_getInstance,
  Key_F4_getInstance295yi03sykfc2 as Key_F4_getInstance,
  Key_L_getInstancelc2peppmic9p as Key_L_getInstance,
  Key_S_getInstance3a623w26n65ct as Key_S_getInstance,
} from './korge-root-korge-core.mjs';
import { get_hz3a5o5age7b808 as get_hz } from './korlibs-time-root-korlibs-time.mjs';
//region block: imports
//endregion
//region block: pre-declaration
class main$slambda {
  fb2($this$Korge, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$Korge), $completion);
  }
  le(p1, $completion) {
    return this.fb2(p1 instanceof Stage ? p1 : THROW_CCE(), $completion);
  }
}
class Companion extends ComponentType {
  constructor() {
    Companion_instance_0 = null;
    super();
    Companion_instance_0 = this;
  }
}
class Companion_0 extends ComponentType {
  constructor() {
    Companion_instance_1 = null;
    super();
    Companion_instance_1 = this;
  }
}
class Companion_1 {}
class $serializer {
  constructor() {
    $serializer_instance = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('GameStartConfig', this, 1);
    tmp0_serialDesc.m16('name', false);
    this.ag3_1 = tmp0_serialDesc;
  }
  bg3(encoder, value) {
    var tmp0_desc = this.ag3_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    tmp1_output.n10(tmp0_desc, 0, value.cg3_1);
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.bg3(encoder, value instanceof GameStartConfig ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.ag3_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.xy(tmp0_desc);
    if (tmp5_input.nz()) {
      tmp4_local0 = tmp5_input.hz(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.hz(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp5_input.yy(tmp0_desc);
    return GameStartConfig.dg3(tmp3_bitMask0, tmp4_local0, null);
  }
  yu() {
    return this.ag3_1;
  }
  d17() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance()];
  }
}
class GameStartConfig {
  constructor(name) {
    this.cg3_1 = name;
    EntityFactory_getInstance().xfb(this);
    new MeteoritesSpawnerConfig('meteorites_spawner');
  }
  q3() {
    return this.cg3_1;
  }
  afc(_this__u8e3s4, entity) {
    createAndConfigureEntity(_this__u8e3s4, 'meteorites_spawner');
    // Inline function 'com.github.quillraven.fleks.EntityComponentContext.configure' call
    $l$block: {
      // Inline function 'com.github.quillraven.fleks.EntityService.configure' call
      var this_0 = _this__u8e3s4.i1v_1.v1t().a1u_1;
      var skipFamilyNotify = this_0.s1v_1 === entity.m1u_1 || this_0.q1v_1 === entity.m1u_1;
      var prevUpdateId = this_0.s1v_1;
      this_0.s1v_1 = entity.m1u_1;
      // Inline function 'samples.fleks.entities.config.GameStartConfig.entityConfigure.<anonymous>' call
      this_0.r1v_1;
      this_0.s1v_1 = prevUpdateId;
      if (skipFamilyNotify) {
        break $l$block;
      }
      var compMask = this_0.o1v_1.h1(entity.m1u_1);
      // Inline function 'kotlin.collections.forEach' call
      var indexedObject = this_0.l1v_1.b1u_1;
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var element = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.github.quillraven.fleks.EntityService.configure.<anonymous>' call
        element.p1w(entity, compMask);
      }
    }
    return entity;
  }
  toString() {
    return 'GameStartConfig(name=' + this.cg3_1 + ')';
  }
  hashCode() {
    return getStringHashCode(this.cg3_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GameStartConfig))
      return false;
    var tmp0_other_with_cast = other instanceof GameStartConfig ? other : THROW_CCE();
    if (!(this.cg3_1 === tmp0_other_with_cast.cg3_1))
      return false;
    return true;
  }
  static dg3(seen0, name, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance().ag3_1);
    }
    var $this = createThis(this);
    $this.cg3_1 = name;
    EntityFactory_getInstance().xfb($this);
    new MeteoritesSpawnerConfig('meteorites_spawner');
    return $this;
  }
}
class Companion_2 {}
class $serializer_0 {
  constructor() {
    $serializer_instance_0 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('MeteoriteConfig', this, 1);
    tmp0_serialDesc.m16('name', false);
    this.eg3_1 = tmp0_serialDesc;
  }
  fg3(encoder, value) {
    var tmp0_desc = this.eg3_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    tmp1_output.n10(tmp0_desc, 0, value.gg3_1);
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.fg3(encoder, value instanceof MeteoriteConfig ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.eg3_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.xy(tmp0_desc);
    if (tmp5_input.nz()) {
      tmp4_local0 = tmp5_input.hz(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.hz(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp5_input.yy(tmp0_desc);
    return MeteoriteConfig.hg3(tmp3_bitMask0, tmp4_local0, null);
  }
  yu() {
    return this.eg3_1;
  }
  d17() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance()];
  }
}
class MeteoriteConfig {
  constructor(name) {
    this.gg3_1 = name;
    EntityFactory_getInstance().xfb(this);
    new MeteoriteTrailConfig('meteorite_trails');
  }
  q3() {
    return this.gg3_1;
  }
  afc(_this__u8e3s4, entity) {
    // Inline function 'com.github.quillraven.fleks.EntityComponentContext.configure' call
    $l$block: {
      // Inline function 'com.github.quillraven.fleks.EntityService.configure' call
      var this_0 = _this__u8e3s4.i1v_1.v1t().a1u_1;
      var skipFamilyNotify = this_0.s1v_1 === entity.m1u_1 || this_0.q1v_1 === entity.m1u_1;
      var prevUpdateId = this_0.s1v_1;
      this_0.s1v_1 = entity.m1u_1;
      // Inline function 'samples.fleks.entities.config.MeteoriteConfig.entityConfigure.<anonymous>' call
      var $this$configure = this_0.r1v_1;
      // Inline function 'com.github.quillraven.fleks.EntityComponentContext.getOrNull' call
      var type = Companion_getInstance_0();
      // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
      var this_1 = $this$configure.i1v_1;
      if (this_1.u1t_1.j1s(type.m1t())) {
        var tmp = type.m1t();
        var tmp_0 = this_1.v1t();
        var tmp_1 = 0;
        var tmp_2 = this_1.v1t().g1s();
        // Inline function 'kotlin.arrayOfNulls' call
        var tmp_3 = fillArrayVal(Array(tmp_2), null);
        while (tmp_1 < tmp_2) {
          tmp_3[tmp_1] = null;
          tmp_1 = tmp_1 + 1 | 0;
        }
        this_1.u1t_1.h1s(tmp, new ComponentsHolder(tmp_0, type, tmp_3));
      }
      var tmp_4 = this_1.u1t_1.h1(type.m1t());
      var tmp0_safe_receiver = (tmp_4 instanceof ComponentsHolder ? tmp_4 : THROW_CCE()).v1u(entity);
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp_5 = tmp0_safe_receiver;
        var tmp_6 = tmp0_safe_receiver.peo_1;
        // Inline function 'kotlin.ranges.random' call
        var this_2 = numberRangeToNumber(-100, 100);
        tmp_5.peo_1 = tmp_6 + random(this_2, Default_getInstance());
      }
      $this$configure.h1v(entity, ScreenCoordinatesTag_getInstance());
      // Inline function 'com.github.quillraven.fleks.EntityCreateContext.plusAssign' call
      // Inline function 'kotlin.ranges.random' call
      var this_3 = numberRangeToNumber(-10, 10);
      var tmp_7 = 90.0 + random(this_3, Default_getInstance());
      // Inline function 'kotlin.ranges.random' call
      var this_4 = numberRangeToNumber(-10, 10);
      var tmp$ret$7 = random(this_4, Default_getInstance());
      var component = MotionComponent.ier(VOID, VOID, tmp_7, 200.0 + tmp$ret$7);
      var compType = component.q1t();
      $this$configure.f1v_1.h1(entity.m1u_1).p1s(compType.m1t());
      // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
      var this_5 = $this$configure.i1v_1;
      if (this_5.u1t_1.j1s(compType.m1t())) {
        var tmp_8 = compType.m1t();
        var tmp_9 = this_5.v1t();
        var tmp_10 = 0;
        var tmp_11 = this_5.v1t().g1s();
        // Inline function 'kotlin.arrayOfNulls' call
        var tmp_12 = fillArrayVal(Array(tmp_11), null);
        while (tmp_10 < tmp_11) {
          tmp_12[tmp_10] = null;
          tmp_10 = tmp_10 + 1 | 0;
        }
        this_5.u1t_1.h1s(tmp_8, new ComponentsHolder(tmp_9, compType, tmp_12));
      }
      var tmp_13 = this_5.u1t_1.h1(compType.m1t());
      var holder = tmp_13 instanceof ComponentsHolder ? tmp_13 : THROW_CCE();
      holder.l1u(entity, component);
      // Inline function 'com.github.quillraven.fleks.EntityCreateContext.plusAssign' call
      var component_0 = SpawnerComponent.bey(5, 1, VOID, 5.0, VOID, 'meteorite_trails');
      var compType_0 = component_0.q1t();
      $this$configure.f1v_1.h1(entity.m1u_1).p1s(compType_0.m1t());
      // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
      var this_6 = $this$configure.i1v_1;
      if (this_6.u1t_1.j1s(compType_0.m1t())) {
        var tmp_14 = compType_0.m1t();
        var tmp_15 = this_6.v1t();
        var tmp_16 = 0;
        var tmp_17 = this_6.v1t().g1s();
        // Inline function 'kotlin.arrayOfNulls' call
        var tmp_18 = fillArrayVal(Array(tmp_17), null);
        while (tmp_16 < tmp_17) {
          tmp_18[tmp_16] = null;
          tmp_16 = tmp_16 + 1 | 0;
        }
        this_6.u1t_1.h1s(tmp_14, new ComponentsHolder(tmp_15, compType_0, tmp_18));
      }
      var tmp_19 = this_6.u1t_1.h1(compType_0.m1t());
      var holder_0 = tmp_19 instanceof ComponentsHolder ? tmp_19 : THROW_CCE();
      holder_0.l1u(entity, component_0);
      this_0.s1v_1 = prevUpdateId;
      if (skipFamilyNotify) {
        break $l$block;
      }
      var compMask = this_0.o1v_1.h1(entity.m1u_1);
      // Inline function 'kotlin.collections.forEach' call
      var indexedObject = this_0.l1v_1.b1u_1;
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var element = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.github.quillraven.fleks.EntityService.configure.<anonymous>' call
        element.p1w(entity, compMask);
      }
    }
    return entity;
  }
  toString() {
    return 'MeteoriteConfig(name=' + this.gg3_1 + ')';
  }
  hashCode() {
    return getStringHashCode(this.gg3_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MeteoriteConfig))
      return false;
    var tmp0_other_with_cast = other instanceof MeteoriteConfig ? other : THROW_CCE();
    if (!(this.gg3_1 === tmp0_other_with_cast.gg3_1))
      return false;
    return true;
  }
  static hg3(seen0, name, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_0().eg3_1);
    }
    var $this = createThis(this);
    $this.gg3_1 = name;
    EntityFactory_getInstance().xfb($this);
    new MeteoriteTrailConfig('meteorite_trails');
    return $this;
  }
}
class Companion_3 {}
class $serializer_1 {
  constructor() {
    $serializer_instance_1 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('MeteoriteTrailConfig', this, 1);
    tmp0_serialDesc.m16('name', false);
    this.ig3_1 = tmp0_serialDesc;
  }
  jg3(encoder, value) {
    var tmp0_desc = this.ig3_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    tmp1_output.n10(tmp0_desc, 0, value.kg3_1);
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.jg3(encoder, value instanceof MeteoriteTrailConfig ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.ig3_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.xy(tmp0_desc);
    if (tmp5_input.nz()) {
      tmp4_local0 = tmp5_input.hz(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.hz(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp5_input.yy(tmp0_desc);
    return MeteoriteTrailConfig.lg3(tmp3_bitMask0, tmp4_local0, null);
  }
  yu() {
    return this.ig3_1;
  }
  d17() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance()];
  }
}
class MeteoriteTrailConfig {
  constructor(name) {
    this.kg3_1 = name;
    EntityFactory_getInstance().xfb(this);
  }
  q3() {
    return this.kg3_1;
  }
  afc(_this__u8e3s4, entity) {
    // Inline function 'com.github.quillraven.fleks.EntityComponentContext.configure' call
    $l$block: {
      // Inline function 'com.github.quillraven.fleks.EntityService.configure' call
      var this_0 = _this__u8e3s4.i1v_1.v1t().a1u_1;
      var skipFamilyNotify = this_0.s1v_1 === entity.m1u_1 || this_0.q1v_1 === entity.m1u_1;
      var prevUpdateId = this_0.s1v_1;
      this_0.s1v_1 = entity.m1u_1;
      // Inline function 'samples.fleks.entities.config.MeteoriteTrailConfig.entityConfigure.<anonymous>' call
      var $this$configure = this_0.r1v_1;
      $this$configure.h1v(entity, ScreenCoordinatesTag_getInstance());
      // Inline function 'com.github.quillraven.fleks.EntityCreateContext.plusAssign' call
      var tmp = -30.0;
      // Inline function 'kotlin.ranges.random' call
      var this_1 = numberRangeToNumber(-15, 15);
      var tmp_0 = tmp + random(this_1, Default_getInstance());
      var tmp_1 = -100.0;
      // Inline function 'kotlin.ranges.random' call
      var this_2 = numberRangeToNumber(-15, 15);
      var tmp$ret$1 = random(this_2, Default_getInstance());
      var component = MotionComponent.ier(VOID, VOID, tmp_0, tmp_1 + tmp$ret$1);
      var compType = component.q1t();
      $this$configure.f1v_1.h1(entity.m1u_1).p1s(compType.m1t());
      // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
      var this_3 = $this$configure.i1v_1;
      if (this_3.u1t_1.j1s(compType.m1t())) {
        var tmp_2 = compType.m1t();
        var tmp_3 = this_3.v1t();
        var tmp_4 = 0;
        var tmp_5 = this_3.v1t().g1s();
        // Inline function 'kotlin.arrayOfNulls' call
        var tmp_6 = fillArrayVal(Array(tmp_5), null);
        while (tmp_4 < tmp_5) {
          tmp_6[tmp_4] = null;
          tmp_4 = tmp_4 + 1 | 0;
        }
        this_3.u1t_1.h1s(tmp_2, new ComponentsHolder(tmp_3, compType, tmp_6));
      }
      var tmp_7 = this_3.u1t_1.h1(compType.m1t());
      var holder = tmp_7 instanceof ComponentsHolder ? tmp_7 : THROW_CCE();
      holder.l1u(entity, component);
      // Inline function 'com.github.quillraven.fleks.EntityCreateContext.plusAssign' call
      var component_0 = SpriteComponent.uey('meteorite', VOID, VOID, 'FireTrail', VOID, true, Direction_ONCE_FORWARD_getInstance(), true);
      var compType_0 = component_0.q1t();
      $this$configure.f1v_1.h1(entity.m1u_1).p1s(compType_0.m1t());
      // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
      var this_4 = $this$configure.i1v_1;
      if (this_4.u1t_1.j1s(compType_0.m1t())) {
        var tmp_8 = compType_0.m1t();
        var tmp_9 = this_4.v1t();
        var tmp_10 = 0;
        var tmp_11 = this_4.v1t().g1s();
        // Inline function 'kotlin.arrayOfNulls' call
        var tmp_12 = fillArrayVal(Array(tmp_11), null);
        while (tmp_10 < tmp_11) {
          tmp_12[tmp_10] = null;
          tmp_10 = tmp_10 + 1 | 0;
        }
        this_4.u1t_1.h1s(tmp_8, new ComponentsHolder(tmp_9, compType_0, tmp_12));
      }
      var tmp_13 = this_4.u1t_1.h1(compType_0.m1t());
      var holder_0 = tmp_13 instanceof ComponentsHolder ? tmp_13 : THROW_CCE();
      holder_0.l1u(entity, component_0);
      // Inline function 'com.github.quillraven.fleks.EntityCreateContext.plusAssign' call
      var component_1 = RgbaComponent.xeo();
      var compType_1 = component_1.q1t();
      $this$configure.f1v_1.h1(entity.m1u_1).p1s(compType_1.m1t());
      // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
      var this_5 = $this$configure.i1v_1;
      if (this_5.u1t_1.j1s(compType_1.m1t())) {
        var tmp_14 = compType_1.m1t();
        var tmp_15 = this_5.v1t();
        var tmp_16 = 0;
        var tmp_17 = this_5.v1t().g1s();
        // Inline function 'kotlin.arrayOfNulls' call
        var tmp_18 = fillArrayVal(Array(tmp_17), null);
        while (tmp_16 < tmp_17) {
          tmp_18[tmp_16] = null;
          tmp_16 = tmp_16 + 1 | 0;
        }
        this_5.u1t_1.h1s(tmp_14, new ComponentsHolder(tmp_15, compType_1, tmp_18));
      }
      var tmp_19 = this_5.u1t_1.h1(compType_1.m1t());
      var holder_1 = tmp_19 instanceof ComponentsHolder ? tmp_19 : THROW_CCE();
      holder_1.l1u(entity, component_1);
      $this$configure.h1v(entity, RenderLayerTag_MAIN_EFFECTS_getInstance());
      this_0.s1v_1 = prevUpdateId;
      if (skipFamilyNotify) {
        break $l$block;
      }
      var compMask = this_0.o1v_1.h1(entity.m1u_1);
      // Inline function 'kotlin.collections.forEach' call
      var indexedObject = this_0.l1v_1.b1u_1;
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var element = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.github.quillraven.fleks.EntityService.configure.<anonymous>' call
        element.p1w(entity, compMask);
      }
    }
    return entity;
  }
  toString() {
    return 'MeteoriteTrailConfig(name=' + this.kg3_1 + ')';
  }
  hashCode() {
    return getStringHashCode(this.kg3_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MeteoriteTrailConfig))
      return false;
    var tmp0_other_with_cast = other instanceof MeteoriteTrailConfig ? other : THROW_CCE();
    if (!(this.kg3_1 === tmp0_other_with_cast.kg3_1))
      return false;
    return true;
  }
  static lg3(seen0, name, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_1().ig3_1);
    }
    var $this = createThis(this);
    $this.kg3_1 = name;
    EntityFactory_getInstance().xfb($this);
    return $this;
  }
}
class Companion_4 {}
class $serializer_2 {
  constructor() {
    $serializer_instance_2 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('MeteoritesSpawnerConfig', this, 1);
    tmp0_serialDesc.m16('name', false);
    this.mg3_1 = tmp0_serialDesc;
  }
  ng3(encoder, value) {
    var tmp0_desc = this.mg3_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    tmp1_output.n10(tmp0_desc, 0, value.og3_1);
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.ng3(encoder, value instanceof MeteoritesSpawnerConfig ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.mg3_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.xy(tmp0_desc);
    if (tmp5_input.nz()) {
      tmp4_local0 = tmp5_input.hz(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.hz(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp5_input.yy(tmp0_desc);
    return MeteoritesSpawnerConfig.pg3(tmp3_bitMask0, tmp4_local0, null);
  }
  yu() {
    return this.mg3_1;
  }
  d17() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance()];
  }
}
class MeteoritesSpawnerConfig {
  constructor(name) {
    this.og3_1 = name;
    EntityFactory_getInstance().xfb(this);
    new MeteoriteConfig('meteorite');
  }
  q3() {
    return this.og3_1;
  }
  afc(_this__u8e3s4, entity) {
    // Inline function 'com.github.quillraven.fleks.EntityComponentContext.configure' call
    $l$block: {
      // Inline function 'com.github.quillraven.fleks.EntityService.configure' call
      var this_0 = _this__u8e3s4.i1v_1.v1t().a1u_1;
      var skipFamilyNotify = this_0.s1v_1 === entity.m1u_1 || this_0.q1v_1 === entity.m1u_1;
      var prevUpdateId = this_0.s1v_1;
      this_0.s1v_1 = entity.m1u_1;
      // Inline function 'samples.fleks.entities.config.MeteoritesSpawnerConfig.entityConfigure.<anonymous>' call
      var $this$configure = this_0.r1v_1;
      // Inline function 'com.github.quillraven.fleks.EntityCreateContext.plusAssign' call
      var component = PositionComponent.teo(100.0, -10.0);
      var compType = component.q1t();
      $this$configure.f1v_1.h1(entity.m1u_1).p1s(compType.m1t());
      // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
      var this_1 = $this$configure.i1v_1;
      if (this_1.u1t_1.j1s(compType.m1t())) {
        var tmp = compType.m1t();
        var tmp_0 = this_1.v1t();
        var tmp_1 = 0;
        var tmp_2 = this_1.v1t().g1s();
        // Inline function 'kotlin.arrayOfNulls' call
        var tmp_3 = fillArrayVal(Array(tmp_2), null);
        while (tmp_1 < tmp_2) {
          tmp_3[tmp_1] = null;
          tmp_1 = tmp_1 + 1 | 0;
        }
        this_1.u1t_1.h1s(tmp, new ComponentsHolder(tmp_0, compType, tmp_3));
      }
      var tmp_4 = this_1.u1t_1.h1(compType.m1t());
      var holder = tmp_4 instanceof ComponentsHolder ? tmp_4 : THROW_CCE();
      holder.l1u(entity, component);
      $this$configure.h1v(entity, ScreenCoordinatesTag_getInstance());
      // Inline function 'com.github.quillraven.fleks.EntityCreateContext.plusAssign' call
      var component_0 = SpawnerComponent.bey(1, 60, 30, VOID, VOID, 'meteorite');
      var compType_0 = component_0.q1t();
      $this$configure.f1v_1.h1(entity.m1u_1).p1s(compType_0.m1t());
      // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
      var this_2 = $this$configure.i1v_1;
      if (this_2.u1t_1.j1s(compType_0.m1t())) {
        var tmp_5 = compType_0.m1t();
        var tmp_6 = this_2.v1t();
        var tmp_7 = 0;
        var tmp_8 = this_2.v1t().g1s();
        // Inline function 'kotlin.arrayOfNulls' call
        var tmp_9 = fillArrayVal(Array(tmp_8), null);
        while (tmp_7 < tmp_8) {
          tmp_9[tmp_7] = null;
          tmp_7 = tmp_7 + 1 | 0;
        }
        this_2.u1t_1.h1s(tmp_5, new ComponentsHolder(tmp_6, compType_0, tmp_9));
      }
      var tmp_10 = this_2.u1t_1.h1(compType_0.m1t());
      var holder_0 = tmp_10 instanceof ComponentsHolder ? tmp_10 : THROW_CCE();
      holder_0.l1u(entity, component_0);
      this_0.s1v_1 = prevUpdateId;
      if (skipFamilyNotify) {
        break $l$block;
      }
      var compMask = this_0.o1v_1.h1(entity.m1u_1);
      // Inline function 'kotlin.collections.forEach' call
      var indexedObject = this_0.l1v_1.b1u_1;
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var element = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.github.quillraven.fleks.EntityService.configure.<anonymous>' call
        element.p1w(entity, compMask);
      }
    }
    return entity;
  }
  toString() {
    return 'MeteoritesSpawnerConfig(name=' + this.og3_1 + ')';
  }
  hashCode() {
    return getStringHashCode(this.og3_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MeteoritesSpawnerConfig))
      return false;
    var tmp0_other_with_cast = other instanceof MeteoritesSpawnerConfig ? other : THROW_CCE();
    if (!(this.og3_1 === tmp0_other_with_cast.og3_1))
      return false;
    return true;
  }
  static pg3(seen0, name, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_2().mg3_1);
    }
    var $this = createThis(this);
    $this.og3_1 = name;
    EntityFactory_getInstance().xfb($this);
    new MeteoriteConfig('meteorite');
    return $this;
  }
}
class GameScene extends Scene {
  constructor(gameStateConfig, loadSnapshot) {
    loadSnapshot = loadSnapshot === VOID ? false : loadSnapshot;
    super();
    this.ag4_1 = gameStateConfig;
    this.bg4_1 = loadSnapshot;
  }
  qbm(_this__u8e3s4, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_sceneInit__5zuhe0.bind(VOID, _this__u8e3s4, this), $completion);
  }
  rbm(_this__u8e3s4, $completion) {
  }
  sbm($completion) {
    println('Game scene after init');
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    GameStateManager_getInstance().jfg(_get_gameWorld__9fg7e7(this), this.ag4_1, this.bg4_1);
  }
}
class InGameMenuView extends Container {
  static vg6(assetStore, coroutineContext) {
    var $this = this.bbk();
    $this.lg6_1 = coroutineContext;
    var tmp = $this;
    tmp.mg6_1 = InGameMenuView$onPauseAction$lambda;
    var tmp_0 = $this;
    tmp_0.ng6_1 = InGameMenuView$onRewindAction$lambda;
    var tmp_1 = $this;
    tmp_1.og6_1 = InGameMenuView$onForwardAction$lambda;
    var tmp_2 = $this;
    tmp_2.pg6_1 = InGameMenuView$onSaveGameAction$lambda;
    $this.qg6_1 = true;
    var tmp_3 = $this;
    // Inline function 'korlibs.korge.view.animation.imageDataView' call
    var data = assetStore.xek('button_pause');
    // Inline function 'korlibs.korge.view.addTo' call
    var this_0 = ImageDataView.kcs(data, null, false, true);
    // Inline function 'kotlin.apply' call
    var this_1 = addTo(this_0, $this);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'samples.fleks.scenes.hud.InGameMenuView.pauseButton.<anonymous>' call
    this_1.qbx(AppConfig_getInstance().eev_1 * 0.9);
    this_1.rbx(AppConfig_getInstance().hev_1 * 0.03);
    this_1.sch(false);
    // Inline function 'korlibs.korge.input.onClick' call
    var handler = InGameMenuView$pauseButton$lambda($this);
    // Inline function 'korlibs.korge.input.doMouseEvent' call
    var prop = click$factory();
    var tmp1_safe_receiver = this_1 == null ? null : this_1.dbx();
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var n = 0;
      while (n < tmp1_safe_receiver.g1()) {
        // Inline function 'korlibs.korge.input.doMouseEvent.<anonymous>' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        var tmp0_safe_receiver = tmp1_safe_receiver.h1(_unary__edvuaz);
        var tmp1_safe_receiver_0 = tmp0_safe_receiver == null ? null : get_mouse(tmp0_safe_receiver);
        if (tmp1_safe_receiver_0 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          var tmp_4 = prop.get(tmp1_safe_receiver_0);
          tmp_4.k38(InGameMenuView$pauseButton$lambda_0(handler));
        }
      }
    }
    tmp_3.rg6_1 = this_1;
    var tmp_5 = $this;
    // Inline function 'samples.fleks.scenes.hud.touchButtonView' call
    var data_0 = assetStore.xek('button_fast_forward');
    // Inline function 'korlibs.korge.view.addTo' call
    var this_2 = TouchButtonView.vg9(data_0);
    // Inline function 'kotlin.apply' call
    var this_3 = addTo(this_2, $this);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'samples.fleks.scenes.hud.InGameMenuView.fastForwardButton.<anonymous>' call
    alignRightToLeftOf(this_3, $this.rg6_1, 9);
    var tmp_6 = this_3;
    tmp_6.ug9_1 = InGameMenuView$fastForwardButton$lambda($this);
    tmp_5.sg6_1 = this_3;
    var tmp_7 = $this;
    // Inline function 'samples.fleks.scenes.hud.touchButtonView' call
    var data_1 = assetStore.xek('button_forward');
    // Inline function 'korlibs.korge.view.addTo' call
    var this_4 = TouchButtonView.vg9(data_1);
    // Inline function 'kotlin.apply' call
    var this_5 = addTo(this_4, $this);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'samples.fleks.scenes.hud.InGameMenuView.forwardButton.<anonymous>' call
    alignRightToLeftOf(this_5, $this.sg6_1, 3);
    var tmp_8 = this_5;
    tmp_8.ug9_1 = InGameMenuView$forwardButton$lambda($this);
    tmp_7.tg6_1 = this_5;
    var tmp_9 = $this;
    // Inline function 'samples.fleks.scenes.hud.touchButtonView' call
    var data_2 = assetStore.xek('button_rewind');
    // Inline function 'korlibs.korge.view.addTo' call
    var this_6 = TouchButtonView.vg9(data_2);
    // Inline function 'kotlin.apply' call
    var this_7 = addTo(this_6, $this);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'samples.fleks.scenes.hud.InGameMenuView.rewindButton.<anonymous>' call
    alignRightToLeftOf(this_7, $this.tg6_1, 3);
    var tmp_10 = this_7;
    tmp_10.ug9_1 = InGameMenuView$rewindButton$lambda($this);
    tmp_9.ug6_1 = this_7;
    // Inline function 'samples.fleks.scenes.hud.touchButtonView' call
    var data_3 = assetStore.xek('button_fast_rewind');
    // Inline function 'korlibs.korge.view.addTo' call
    var this_8 = TouchButtonView.vg9(data_3);
    // Inline function 'kotlin.apply' call
    var this_9 = addTo(this_8, $this);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'samples.fleks.scenes.hud.InGameMenuView.<anonymous>' call
    alignRightToLeftOf(this_9, $this.ug6_1, 3);
    var tmp_11 = this_9;
    tmp_11.ug9_1 = InGameMenuView$lambda($this);
    // Inline function 'korlibs.korge.input.keys' call
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'samples.fleks.scenes.hud.InGameMenuView.<anonymous>' call
    var $this$keys = get_keys($this);
    var tmp_12 = Key_P_getInstance();
    $this$keys.pbe(tmp_12, InGameMenuView$lambda_0($this));
    var tmp_13 = Key_F1_getInstance();
    // Inline function 'korlibs.time.seconds' call
    // Inline function 'korlibs.time.seconds' call
    var this_10 = 1 / 30.0;
    var tmp_14 = toDuration(this_10, DurationUnit_SECONDS_getInstance());
    $this$keys.nbe(tmp_13, tmp_14, InGameMenuView$lambda_1($this));
    var tmp_15 = Key_F2_getInstance();
    // Inline function 'korlibs.time.seconds' call
    // Inline function 'korlibs.time.seconds' call
    var this_11 = 1 / 30.0;
    var tmp_16 = toDuration(this_11, DurationUnit_SECONDS_getInstance());
    $this$keys.nbe(tmp_15, tmp_16, InGameMenuView$lambda_2($this));
    var tmp_17 = Key_F3_getInstance();
    // Inline function 'korlibs.time.seconds' call
    // Inline function 'korlibs.time.seconds' call
    var this_12 = 1 / 30.0;
    var tmp_18 = toDuration(this_12, DurationUnit_SECONDS_getInstance());
    $this$keys.nbe(tmp_17, tmp_18, InGameMenuView$lambda_3($this));
    var tmp_19 = Key_F4_getInstance();
    // Inline function 'korlibs.time.seconds' call
    // Inline function 'korlibs.time.seconds' call
    var this_13 = 1 / 30.0;
    var tmp_20 = toDuration(this_13, DurationUnit_SECONDS_getInstance());
    $this$keys.nbe(tmp_19, tmp_20, InGameMenuView$lambda_4($this));
    var tmp_21 = Key_L_getInstance();
    $this$keys.pbe(tmp_21, InGameMenuView$lambda_5($this));
    var tmp_22 = Key_S_getInstance();
    $this$keys.pbe(tmp_22, InGameMenuView$lambda_6($this));
    return $this;
  }
}
class TouchButtonView extends ImageDataView {
  static vg9(data) {
    var $this = this.kcs(data);
    var tmp = $this;
    tmp.ug9_1 = TouchButtonView$onPressed$lambda;
    $this.rbx(AppConfig_getInstance().hev_1 * 0.03);
    $this.sch(false);
    var pressed = {_v: false};
    var tmp_0 = get_hz(30);
    addFixedUpdater($this, tmp_0, VOID, VOID, TouchButtonView$lambda(pressed));
    // Inline function 'korlibs.korge.input.onDown' call
    var handler = TouchButtonView$lambda_0(pressed);
    // Inline function 'korlibs.korge.input.doMouseEvent' call
    var prop = down$factory_0();
    var tmp1_safe_receiver = $this == null ? null : $this.dbx();
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var n = 0;
      while (n < tmp1_safe_receiver.g1()) {
        // Inline function 'korlibs.korge.input.doMouseEvent.<anonymous>' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        var tmp0_safe_receiver = tmp1_safe_receiver.h1(_unary__edvuaz);
        var tmp1_safe_receiver_0 = tmp0_safe_receiver == null ? null : get_mouse(tmp0_safe_receiver);
        if (tmp1_safe_receiver_0 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          var tmp_1 = prop.get(tmp1_safe_receiver_0);
          tmp_1.k38(TouchButtonView$lambda_1(handler));
        }
      }
    }
    // Inline function 'korlibs.korge.input.onUp' call
    var handler_0 = TouchButtonView$lambda_2(pressed);
    // Inline function 'korlibs.korge.input.doMouseEvent' call
    var prop_0 = up$factory_0();
    var tmp1_safe_receiver_1 = $this == null ? null : $this.dbx();
    if (tmp1_safe_receiver_1 == null)
      null;
    else {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var n_0 = 0;
      while (n_0 < tmp1_safe_receiver_1.g1()) {
        // Inline function 'korlibs.korge.input.doMouseEvent.<anonymous>' call
        var _unary__edvuaz_0 = n_0;
        n_0 = _unary__edvuaz_0 + 1 | 0;
        var tmp0_safe_receiver_0 = tmp1_safe_receiver_1.h1(_unary__edvuaz_0);
        var tmp1_safe_receiver_2 = tmp0_safe_receiver_0 == null ? null : get_mouse(tmp0_safe_receiver_0);
        if (tmp1_safe_receiver_2 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          var tmp_2 = prop_0.get(tmp1_safe_receiver_2);
          tmp_2.k38(TouchButtonView$lambda_3(handler_0));
        }
      }
    }
    // Inline function 'korlibs.korge.input.onOut' call
    var handler_1 = TouchButtonView$lambda_4(pressed);
    // Inline function 'korlibs.korge.input.doMouseEvent' call
    var prop_1 = out$factory();
    var tmp1_safe_receiver_3 = $this == null ? null : $this.dbx();
    if (tmp1_safe_receiver_3 == null)
      null;
    else {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var n_1 = 0;
      while (n_1 < tmp1_safe_receiver_3.g1()) {
        // Inline function 'korlibs.korge.input.doMouseEvent.<anonymous>' call
        var _unary__edvuaz_1 = n_1;
        n_1 = _unary__edvuaz_1 + 1 | 0;
        var tmp0_safe_receiver_1 = tmp1_safe_receiver_3.h1(_unary__edvuaz_1);
        var tmp1_safe_receiver_4 = tmp0_safe_receiver_1 == null ? null : get_mouse(tmp0_safe_receiver_1);
        if (tmp1_safe_receiver_4 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          var tmp_3 = prop_1.get(tmp1_safe_receiver_4);
          tmp_3.k38(TouchButtonView$lambda_5(handler_1));
        }
      }
    }
    return $this;
  }
}
class CollisionSystem extends IteratingSystem {
  static fg7() {
    var tmp = Companion_instance;
    return this.z1z(tmp.p20(CollisionSystem$_init_$lambda_k5g4sq), VOID, VOID, EachFrame_instance);
  }
  c20(entity) {
    // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
    var type = Companion_getInstance_0();
    // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
    var this_0 = this.i1v_1;
    if (this_0.u1t_1.j1s(type.m1t())) {
      var tmp = type.m1t();
      var tmp_0 = this_0.v1t();
      var tmp_1 = 0;
      var tmp_2 = this_0.v1t().g1s();
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp_3 = fillArrayVal(Array(tmp_2), null);
      while (tmp_1 < tmp_2) {
        tmp_3[tmp_1] = null;
        tmp_1 = tmp_1 + 1 | 0;
      }
      this_0.u1t_1.h1s(tmp, new ComponentsHolder(tmp_0, type, tmp_3));
    }
    var tmp_4 = this_0.u1t_1.h1(type.m1t());
    var pos = (tmp_4 instanceof ComponentsHolder ? tmp_4 : THROW_CCE()).p1u(entity);
    // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
    var type_0 = Companion_getInstance_1();
    // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
    var this_1 = this.i1v_1;
    if (this_1.u1t_1.j1s(type_0.m1t())) {
      var tmp_5 = type_0.m1t();
      var tmp_6 = this_1.v1t();
      var tmp_7 = 0;
      var tmp_8 = this_1.v1t().g1s();
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp_9 = fillArrayVal(Array(tmp_8), null);
      while (tmp_7 < tmp_8) {
        tmp_9[tmp_7] = null;
        tmp_7 = tmp_7 + 1 | 0;
      }
      this_1.u1t_1.h1s(tmp_5, new ComponentsHolder(tmp_6, type_0, tmp_9));
    }
    var tmp_10 = this_1.u1t_1.h1(type_0.m1t());
    var motion = (tmp_10 instanceof ComponentsHolder ? tmp_10 : THROW_CCE()).p1u(entity);
    if (pos.qeo_1 > 200.0) {
      pos.qeo_1 = 200.0;
      if (this.k1v(entity, Companion_getInstance_5())) {
        // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
        var type_1 = Companion_getInstance_5();
        // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
        var this_2 = this.i1v_1;
        if (this_2.u1t_1.j1s(type_1.m1t())) {
          var tmp_11 = type_1.m1t();
          var tmp_12 = this_2.v1t();
          var tmp_13 = 0;
          var tmp_14 = this_2.v1t().g1s();
          // Inline function 'kotlin.arrayOfNulls' call
          var tmp_15 = fillArrayVal(Array(tmp_14), null);
          while (tmp_13 < tmp_14) {
            tmp_15[tmp_13] = null;
            tmp_13 = tmp_13 + 1 | 0;
          }
          this_2.u1t_1.h1s(tmp_11, new ComponentsHolder(tmp_12, type_1, tmp_15));
        }
        var tmp_16 = this_2.u1t_1.h1(type_1.m1t());
        (tmp_16 instanceof ComponentsHolder ? tmp_16 : THROW_CCE()).p1u(entity).wg9_1 = true;
      } else if (this.k1v(entity, Companion_getInstance_6())) {
        motion.fer_1 = motion.fer_1 * 0.7;
        motion.ger_1 = -motion.ger_1 * 0.9;
      } else {
        this.v1z_1.o1u(entity);
      }
    }
  }
}
//endregion
function *_generator_main__qlaff5($completion) {
  var tmp0_windowSize = Size2D.n3q(384 * 2.0, 216 * 2.0);
  var tmp1_backgroundColor = Colors_getInstance().z57_1;
  var tmp2_title = AppConfig_getInstance().dev_1;
  var tmp = Korge(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp0_windowSize, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp2_title, VOID, tmp1_backgroundColor, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, main$slambda_0(), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function main($completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_main__qlaff5.bind(VOID), $completion);
}
function *_generator_invoke__zhh2q8($this, $this$Korge, $completion) {
  AppConfig_getInstance().pev_1 = 1.0 / get_milliseconds($this$Korge.rbg().qb5_1.ea5());
  var targetVirtualHeight = AppConfig_getInstance().hev_1;
  var targetVirtualZoom = $this$Korge.dci().g3u() / AppConfig_getInstance().hev_1;
  var targetVirtualWidth = numberToInt($this$Korge.dci().f3u() / targetVirtualZoom);
  println('target physical size: (WxH) ' + $this$Korge.dci().f3u() + ' x ' + $this$Korge.dci().g3u());
  println('virtual window size: (WxH) ' + targetVirtualWidth + ' x ' + targetVirtualHeight + ' (zoom: ' + targetVirtualZoom + ')');
  $this$Korge.rbg().ccj(targetVirtualWidth, targetVirtualHeight);
  $this$Korge.rbg().kb7_1 = 60.0;
  AppConfig_getInstance().vg1(targetVirtualWidth);
  var tmp = GameStateManager_getInstance().hfg($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var gameStateConfig = tmp;
  var tmp_0 = GameStateManager_getInstance();
  // Inline function 'kotlinx.serialization.modules.SerializersModule' call
  var builder = new SerializersModuleBuilder();
  // Inline function 'main.<anonymous>.<anonymous>' call
  // Inline function 'kotlinx.serialization.modules.polymorphic' call
  var baseClass = getKClass(EntityConfig);
  var builder_0 = new PolymorphicModuleBuilder(baseClass, null);
  // Inline function 'main.<anonymous>.<anonymous>.<anonymous>' call
  builder_0.q1f(builder);
  var tmp$ret$1 = builder.n14();
  tmp_0.gfg('myModule', tmp$ret$1);
  // Inline function 'korlibs.korge.scene.SceneContainer.changeTo' call
  // Inline function 'korlibs.korge.scene.sceneContainer' call
  var defaultTransition = withEasing(get_AlphaTransition(), get_EASE_IN_OUT_QUAD(Companion_getInstance_4()));
  var name = 'sceneContainer';
  var size = Companion_getInstance().r3s_1;
  // Inline function 'korlibs.korge.scene.sceneContainer' call
  var tmp_1 = views($completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var views_0 = tmp_1;
  var width = size.em();
  var height = size.fm();
  var rwidth = width;
  var rheight = height;
  if (width === 0.0 && height === 0.0) {
    var tmp_2 = findFirstAscendant($this$Korge, main$slambda$lambda);
    var base = (tmp_2 == null ? true : tmp_2 instanceof FixedSizeContainer) ? tmp_2 : null;
    var tmp1_elvis_lhs = base == null ? null : base.f3u();
    rwidth = tmp1_elvis_lhs == null ? views_0.wb6_1.f3u() : tmp1_elvis_lhs;
    var tmp3_elvis_lhs = base == null ? null : base.g3u();
    rheight = tmp3_elvis_lhs == null ? views_0.wb6_1.g3u() : tmp3_elvis_lhs;
  }
  // Inline function 'korlibs.korge.view.addTo' call
  var this_0 = SceneContainer.xbc(views_0, defaultTransition, name, Size2D.r3q(rwidth, rheight));
  // Inline function 'kotlin.apply' call
  var this_1 = addTo(this_0, $this$Korge);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.scene.sceneContainer.<anonymous>' call
  var injects = [];
  // Inline function 'korlibs.time.seconds' call
  // Inline function 'korlibs.time.seconds' call
  var time = toDuration(0, DurationUnit_SECONDS_getInstance());
  var transition = this_1.sbc_1;
  // Inline function 'korlibs.korge.scene.SceneContainer.changeTo' call
  var clazz = getKClass(GameScene);
  var injects_0 = injects.slice();
  var sceneInjector = this_1.rbc_1.mb5_1.g7s().e7s(getKClass(SceneContainer), this_1).e7s(getKClass(Resources), new Resources(this_1.z2e(), this_1.rbc_1.tbd().a4h_1, this_1.rbc_1.tbd()));
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < injects_0.length) {
    // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var inject = injects_0[_unary__edvuaz];
    var tmp_3 = getKClassFromExpression(inject);
    sceneInjector.e7s(isInterface(tmp_3, KClass) ? tmp_3 : THROW_CCE(), inject);
  }
  // Inline function 'main.<anonymous>.<anonymous>' call
  var newScene = new GameScene(gameStateConfig);
  // Inline function 'korlibs.logger.Logger.info' call
  var this_2 = Companion_getInstance_3().rbn_1;
  var level = Level_INFO_getInstance();
  var tmp_4;
  if (this_2.q46(level)) {
    // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
    var tmp$ret$10 = 'Changing scene to... ' + toString(clazz) + ' ... ' + toString(newScene);
    this_2.r46(level, tmp$ret$10);
    tmp_4 = Unit_instance;
  }
  if (true) {
    newScene.p7s(sceneInjector);
    var tmp_5 = getKClassFromExpression(newScene);
    var tmp_6 = isInterface(tmp_5, KClass) ? tmp_5 : THROW_CCE();
    this_1.rbc_1.mb5_1.i7s(tmp_6, main$slambda$lambda_0(sceneInjector, gameStateConfig));
  }
  var tmp_7 = this_1.tbn(newScene, time, transition, $completion);
  if (tmp_7 === get_COROUTINE_SUSPENDED())
    tmp_7 = yield tmp_7;
  return Unit_instance;
}
function main$slambda$lambda(it) {
  return it instanceof FixedSizeContainer;
}
function main$slambda$lambda_0($sceneInjector, $gameStateConfig) {
  return function ($this$mapPrototype) {
    // Inline function 'main.<anonymous>.<anonymous>' call
    return new GameScene($gameStateConfig);
  };
}
function main$slambda_0() {
  var i = new main$slambda();
  var l = function ($this$Korge, $completion) {
    return i.fb2($this$Korge, $completion);
  };
  l.$arity = 1;
  return l;
}
function mainWrapper() {
  startCoroutineUninterceptedOrReturnGeneratorVersion(main, get_EmptyContinuation());
}
var Companion_instance_0;
function Companion_getInstance_5() {
  if (Companion_instance_0 === VOID)
    new Companion();
  return Companion_instance_0;
}
var Companion_instance_1;
function Companion_getInstance_6() {
  if (Companion_instance_1 === VOID)
    new Companion_0();
  return Companion_instance_1;
}
var Companion_instance_2;
function Companion_getInstance_7() {
  return Companion_instance_2;
}
var $serializer_instance;
function $serializer_getInstance() {
  if ($serializer_instance === VOID)
    new $serializer();
  return $serializer_instance;
}
var Companion_instance_3;
function Companion_getInstance_8() {
  return Companion_instance_3;
}
var $serializer_instance_0;
function $serializer_getInstance_0() {
  if ($serializer_instance_0 === VOID)
    new $serializer_0();
  return $serializer_instance_0;
}
var Companion_instance_4;
function Companion_getInstance_9() {
  return Companion_instance_4;
}
var $serializer_instance_1;
function $serializer_getInstance_1() {
  if ($serializer_instance_1 === VOID)
    new $serializer_1();
  return $serializer_instance_1;
}
var Companion_instance_5;
function Companion_getInstance_10() {
  return Companion_instance_5;
}
var $serializer_instance_2;
function $serializer_getInstance_2() {
  if ($serializer_instance_2 === VOID)
    new $serializer_2();
  return $serializer_instance_2;
}
function _get_gameWorld__9fg7e7($this) {
  var tmp = $this.cg4_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('gameWorld');
  }
}
function *_generator_sceneInit__5zuhe0(_this__u8e3s4, $this, $completion) {
  println('Game scene init');
  var tmp = $this.rbg().qb5_1.za4();
  // Inline function 'kotlin.time.Companion.seconds' call
  Companion_getInstance_2();
  tmp.ta4_1 = toDuration_0(10, DurationUnit_SECONDS_getInstance());
  var tmp_0 = GameStateManager_getInstance().ifg($this.ag4_1, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var estimatedNumberOfEntities = 1024;
  var tmp_1 = $this;
  tmp_1.cg4_1 = configureWorld(estimatedNumberOfEntities, GameScene$sceneInit$lambda);
  new MainCameraConfig('main_camera');
  createAndConfigureEntity(_get_gameWorld__9fg7e7($this), 'main_camera');
  new GameStartConfig('start_game');
  addUpdater(_this__u8e3s4, GameScene$sceneInit$lambda_0($this));
  // Inline function 'korlibs.korge.fleks.renderSystems.levelMapRenderSystem' call
  var world = _get_gameWorld__9fg7e7($this);
  var layerTag = RenderLayerTag_BG_LEVELMAP_getInstance();
  // Inline function 'korlibs.korge.view.addTo' call
  var this_0 = LevelMapRenderSystem.xfm(world, layerTag);
  // Inline function 'kotlin.apply' call
  addTo(this_0, _this__u8e3s4);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.fleks.renderSystems.levelMapRenderSystem.<anonymous>' call
  // Inline function 'korlibs.korge.fleks.renderSystems.parallaxRenderSystem' call
  var world_0 = _get_gameWorld__9fg7e7($this);
  var layerTag_0 = RenderLayerTag_BG_PARALLAX_getInstance();
  // Inline function 'korlibs.korge.view.addTo' call
  var this_1 = ParallaxRenderSystem.gfr(world_0, layerTag_0);
  // Inline function 'kotlin.apply' call
  addTo(this_1, _this__u8e3s4);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.fleks.renderSystems.parallaxRenderSystem.<anonymous>' call
  // Inline function 'korlibs.korge.fleks.renderSystems.levelMapRenderSystem' call
  var world_1 = _get_gameWorld__9fg7e7($this);
  var layerTag_1 = RenderLayerTag_MAIN_LEVELMAP_getInstance();
  // Inline function 'korlibs.korge.view.addTo' call
  var this_2 = LevelMapRenderSystem.xfm(world_1, layerTag_1);
  // Inline function 'kotlin.apply' call
  addTo(this_2, _this__u8e3s4);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.fleks.renderSystems.levelMapRenderSystem.<anonymous>' call
  // Inline function 'korlibs.korge.fleks.renderSystems.objectRenderSystem' call
  var world_2 = _get_gameWorld__9fg7e7($this);
  var layerTag_2 = RenderLayerTag_MAIN_SPRITES_getInstance();
  // Inline function 'korlibs.korge.view.addTo' call
  var this_3 = ObjectRenderSystem.cfp(world_2, layerTag_2);
  // Inline function 'kotlin.apply' call
  addTo(this_3, _this__u8e3s4);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.fleks.renderSystems.objectRenderSystem.<anonymous>' call
  // Inline function 'korlibs.korge.fleks.renderSystems.fastSpriteRenderSystem' call
  var world_3 = _get_gameWorld__9fg7e7($this);
  var layerTag_3 = RenderLayerTag_MAIN_EFFECTS_getInstance();
  // Inline function 'korlibs.korge.view.addTo' call
  var this_4 = FastSpriteRenderSystem.sfk(world_3, layerTag_3);
  // Inline function 'kotlin.apply' call
  addTo(this_4, _this__u8e3s4);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.fleks.renderSystems.fastSpriteRenderSystem.<anonymous>' call
  // Inline function 'korlibs.korge.fleks.renderSystems.objectRenderSystem' call
  var world_4 = _get_gameWorld__9fg7e7($this);
  var layerTag_4 = RenderLayerTag_MAIN_FOREGROUND_getInstance();
  // Inline function 'korlibs.korge.view.addTo' call
  var this_5 = ObjectRenderSystem.cfp(world_4, layerTag_4);
  // Inline function 'kotlin.apply' call
  addTo(this_5, _this__u8e3s4);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.fleks.renderSystems.objectRenderSystem.<anonymous>' call
  // Inline function 'korlibs.korge.fleks.renderSystems.levelMapRenderSystem' call
  var world_5 = _get_gameWorld__9fg7e7($this);
  var layerTag_5 = RenderLayerTag_FG_LEVELMAP_getInstance();
  // Inline function 'korlibs.korge.view.addTo' call
  var this_6 = LevelMapRenderSystem.xfm(world_5, layerTag_5);
  // Inline function 'kotlin.apply' call
  addTo(this_6, _this__u8e3s4);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.fleks.renderSystems.levelMapRenderSystem.<anonymous>' call
  // Inline function 'korlibs.korge.fleks.renderSystems.parallaxRenderSystem' call
  var world_6 = _get_gameWorld__9fg7e7($this);
  var layerTag_6 = RenderLayerTag_FG_PARALLAX_getInstance();
  // Inline function 'korlibs.korge.view.addTo' call
  var this_7 = ParallaxRenderSystem.gfr(world_6, layerTag_6);
  // Inline function 'kotlin.apply' call
  addTo(this_7, _this__u8e3s4);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.fleks.renderSystems.parallaxRenderSystem.<anonymous>' call
  // Inline function 'korlibs.korge.fleks.renderSystems.objectRenderSystem' call
  var world_7 = _get_gameWorld__9fg7e7($this);
  var layerTag_7 = RenderLayerTag_FG_DIALOGS_getInstance();
  // Inline function 'korlibs.korge.view.addTo' call
  var this_8 = ObjectRenderSystem.cfp(world_7, layerTag_7);
  // Inline function 'kotlin.apply' call
  addTo(this_8, _this__u8e3s4);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.fleks.renderSystems.objectRenderSystem.<anonymous>' call
  // Inline function 'korlibs.korge.fleks.renderSystems.debugRenderSystem' call
  var world_8 = _get_gameWorld__9fg7e7($this);
  var layerTag_8 = RenderLayerTag_DEBUG_getInstance();
  // Inline function 'korlibs.korge.view.addTo' call
  var this_9 = DebugRenderSystem.ofi(world_8, layerTag_8);
  // Inline function 'kotlin.apply' call
  addTo(this_9, _this__u8e3s4);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.fleks.renderSystems.debugRenderSystem.<anonymous>' call
  // Inline function 'korlibs.korge.input.onDown' call
  var handler = GameScene$sceneInit$lambda_1($this);
  // Inline function 'korlibs.korge.input.doMouseEvent' call
  var prop = down$factory();
  var tmp1_safe_receiver = _this__u8e3s4 == null ? null : _this__u8e3s4.dbx();
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n = 0;
    while (n < tmp1_safe_receiver.g1()) {
      // Inline function 'korlibs.korge.input.doMouseEvent.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var tmp0_safe_receiver = tmp1_safe_receiver.h1(_unary__edvuaz);
      var tmp1_safe_receiver_0 = tmp0_safe_receiver == null ? null : get_mouse(tmp0_safe_receiver);
      if (tmp1_safe_receiver_0 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp_2 = prop.get(tmp1_safe_receiver_0);
        tmp_2.k38(GameScene$sceneInit$lambda_2(handler));
      }
    }
  }
  // Inline function 'korlibs.korge.input.onMove' call
  var handler_0 = GameScene$sceneInit$lambda_3($this);
  // Inline function 'korlibs.korge.input.doMouseEvent' call
  var prop_0 = move$factory();
  var tmp1_safe_receiver_1 = _this__u8e3s4 == null ? null : _this__u8e3s4.dbx();
  if (tmp1_safe_receiver_1 == null)
    null;
  else {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n_0 = 0;
    while (n_0 < tmp1_safe_receiver_1.g1()) {
      // Inline function 'korlibs.korge.input.doMouseEvent.<anonymous>' call
      var _unary__edvuaz_0 = n_0;
      n_0 = _unary__edvuaz_0 + 1 | 0;
      var tmp0_safe_receiver_0 = tmp1_safe_receiver_1.h1(_unary__edvuaz_0);
      var tmp1_safe_receiver_2 = tmp0_safe_receiver_0 == null ? null : get_mouse(tmp0_safe_receiver_0);
      if (tmp1_safe_receiver_2 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp_3 = prop_0.get(tmp1_safe_receiver_2);
        tmp_3.k38(GameScene$sceneInit$lambda_4(handler_0));
      }
    }
  }
  // Inline function 'korlibs.korge.input.onUp' call
  var handler_1 = GameScene$sceneInit$lambda_5($this);
  // Inline function 'korlibs.korge.input.doMouseEvent' call
  var prop_1 = up$factory();
  var tmp1_safe_receiver_3 = _this__u8e3s4 == null ? null : _this__u8e3s4.dbx();
  if (tmp1_safe_receiver_3 == null)
    null;
  else {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n_1 = 0;
    while (n_1 < tmp1_safe_receiver_3.g1()) {
      // Inline function 'korlibs.korge.input.doMouseEvent.<anonymous>' call
      var _unary__edvuaz_1 = n_1;
      n_1 = _unary__edvuaz_1 + 1 | 0;
      var tmp0_safe_receiver_1 = tmp1_safe_receiver_3.h1(_unary__edvuaz_1);
      var tmp1_safe_receiver_4 = tmp0_safe_receiver_1 == null ? null : get_mouse(tmp0_safe_receiver_1);
      if (tmp1_safe_receiver_4 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp_4 = prop_1.get(tmp1_safe_receiver_4);
        tmp_4.k38(GameScene$sceneInit$lambda_6(handler_1));
      }
    }
  }
  // Inline function 'samples.fleks.scenes.hud.inGameMenuView' call
  var assetStore = GameStateManager_getInstance().ceh_1;
  var coroutineContext = $this.z2e();
  // Inline function 'korlibs.korge.view.addTo' call
  var this_10 = InGameMenuView.vg6(assetStore, coroutineContext);
  // Inline function 'kotlin.apply' call
  var this_11 = addTo(this_10, _this__u8e3s4);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'samples.fleks.scenes.GameScene.sceneInit.<anonymous>' call
  var tmp_5 = this_11;
  tmp_5.mg6_1 = GameScene$sceneInit$lambda_7($this);
  var tmp_6 = this_11;
  tmp_6.ng6_1 = GameScene$sceneInit$lambda_8($this);
  var tmp_7 = this_11;
  tmp_7.og6_1 = GameScene$sceneInit$lambda_9($this);
  var tmp_8 = this_11;
  tmp_8.pg6_1 = GameScene$sceneInit$lambda_10($this, this_11);
  return Unit_instance;
}
function GameScene$sceneInit$lambda($this$configureWorld) {
  $this$configureWorld.g21(GameScene$sceneInit$lambda$lambda);
  $this$configureWorld.h21(GameScene$sceneInit$lambda$lambda_0);
  $this$configureWorld.i21(GameScene$sceneInit$lambda$lambda_1);
  return Unit_instance;
}
function GameScene$sceneInit$lambda$lambda($this$injectables) {
  $this$injectables.k21('AssetStore', GameStateManager_getInstance().ceh_1);
  return Unit_instance;
}
function GameScene$sceneInit$lambda$lambda_0($this$families) {
  return Unit_instance;
}
function GameScene$sceneInit$lambda$lambda_1($this$systems) {
  $this$systems.n21(TouchInputSystem.xfw());
  $this$systems.n21(SpawnerSystem.lfv());
  $this$systems.n21(EventSystem.cfs());
  setupTweenEngineSystems($this$systems);
  $this$systems.n21(CollisionSystem.fg7());
  $this$systems.n21(LifeCycleSystem.qfs());
  $this$systems.n21(ParallaxSystem.cft(AppConfig_getInstance().bev_1));
  $this$systems.n21(PositionSystem.mft());
  $this$systems.n21(SpriteLayersSystem.vfv());
  $this$systems.n21(EntityLinkSystem.rfr());
  $this$systems.n21(SpriteSystem.gfw());
  $this$systems.n21(SoundSystem.bfv());
  $this$systems.n21(CameraSystem.hfr(AppConfig_getInstance().bev_1));
  // Inline function 'kotlinx.serialization.modules.SerializersModule' call
  var builder = new SerializersModuleBuilder();
  // Inline function 'samples.fleks.scenes.GameScene.sceneInit.<anonymous>.<anonymous>.<anonymous>' call
  // Inline function 'kotlinx.serialization.modules.polymorphic' call
  var baseClass = getKClass(CloneableData);
  var builder_0 = new PolymorphicModuleBuilder(baseClass, null);
  // Inline function 'samples.fleks.scenes.GameScene.sceneInit.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
  builder_0.q1f(builder);
  // Inline function 'kotlinx.serialization.modules.polymorphic' call
  var baseClass_0 = getKClass(Component);
  var builder_1 = new PolymorphicModuleBuilder(baseClass_0, null);
  // Inline function 'samples.fleks.scenes.GameScene.sceneInit.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
  builder_1.q1f(builder);
  // Inline function 'kotlinx.serialization.modules.polymorphic' call
  var baseClass_1 = getKClass(UniqueId);
  var builder_2 = new PolymorphicModuleBuilder(baseClass_1, null);
  // Inline function 'samples.fleks.scenes.GameScene.sceneInit.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
  builder_2.q1f(builder);
  var tmp$ret$3 = builder.n14();
  $this$systems.n21(SnapshotSerializerSystem.ifu(tmp$ret$3));
  return Unit_instance;
}
function GameScene$sceneInit$lambda_0(this$0) {
  return function ($this$addUpdater, dt) {
    var deltaTime = get_seconds(dt.lk_1);
    _get_gameWorld__9fg7e7(this$0).v20(deltaTime);
    return Unit_instance;
  };
}
function GameScene$sceneInit$lambda_1(this$0) {
  return function (it) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'com.github.quillraven.fleks.World.system' call
      // Inline function 'kotlin.collections.forEach' call
      var tmp0_iterator = _get_gameWorld__9fg7e7(this$0).o20().b1();
      while (tmp0_iterator.c1()) {
        var element = tmp0_iterator.d1();
        // Inline function 'com.github.quillraven.fleks.World.system.<anonymous>' call
        if (element instanceof TouchInputSystem) {
          tmp$ret$0 = element;
          break $l$block;
        }
      }
      throw FleksNoSuchSystemException.o1x(getKClass(TouchInputSystem));
    }
    tmp$ret$0.yfw(it.ubg().r3i_1, it.ubg().s3i_1);
    return Unit_instance;
  };
}
function GameScene$sceneInit$lambda_2($handler) {
  return function (it) {
    $handler(it);
    return Unit_instance;
  };
}
function GameScene$sceneInit$lambda_3(this$0) {
  return function (it) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'com.github.quillraven.fleks.World.system' call
      // Inline function 'kotlin.collections.forEach' call
      var tmp0_iterator = _get_gameWorld__9fg7e7(this$0).o20().b1();
      while (tmp0_iterator.c1()) {
        var element = tmp0_iterator.d1();
        // Inline function 'com.github.quillraven.fleks.World.system.<anonymous>' call
        if (element instanceof TouchInputSystem) {
          tmp$ret$0 = element;
          break $l$block;
        }
      }
      throw FleksNoSuchSystemException.o1x(getKClass(TouchInputSystem));
    }
    tmp$ret$0.zfw(it.ubg().r3i_1, it.ubg().s3i_1);
    return Unit_instance;
  };
}
function GameScene$sceneInit$lambda_4($handler) {
  return function (it) {
    $handler(it);
    return Unit_instance;
  };
}
function GameScene$sceneInit$lambda_5(this$0) {
  return function (it) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'com.github.quillraven.fleks.World.system' call
      // Inline function 'kotlin.collections.forEach' call
      var tmp0_iterator = _get_gameWorld__9fg7e7(this$0).o20().b1();
      while (tmp0_iterator.c1()) {
        var element = tmp0_iterator.d1();
        // Inline function 'com.github.quillraven.fleks.World.system.<anonymous>' call
        if (element instanceof TouchInputSystem) {
          tmp$ret$0 = element;
          break $l$block;
        }
      }
      throw FleksNoSuchSystemException.o1x(getKClass(TouchInputSystem));
    }
    tmp$ret$0.afx(it.ubg().r3i_1, it.ubg().s3i_1);
    return Unit_instance;
  };
}
function GameScene$sceneInit$lambda_6($handler) {
  return function (it) {
    $handler(it);
    return Unit_instance;
  };
}
function GameScene$sceneInit$lambda_7(this$0) {
  return function (it) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'com.github.quillraven.fleks.World.system' call
      // Inline function 'kotlin.collections.forEach' call
      var tmp0_iterator = _get_gameWorld__9fg7e7(this$0).o20().b1();
      while (tmp0_iterator.c1()) {
        var element = tmp0_iterator.d1();
        // Inline function 'com.github.quillraven.fleks.World.system.<anonymous>' call
        if (element instanceof SnapshotSerializerSystem) {
          tmp$ret$0 = element;
          break $l$block;
        }
      }
      throw FleksNoSuchSystemException.o1x(getKClass(SnapshotSerializerSystem));
    }
    tmp$ret$0.mfu();
    return Unit_instance;
  };
}
function GameScene$sceneInit$lambda_8(this$0) {
  return function (fast) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'com.github.quillraven.fleks.World.system' call
      // Inline function 'kotlin.collections.forEach' call
      var tmp0_iterator = _get_gameWorld__9fg7e7(this$0).o20().b1();
      while (tmp0_iterator.c1()) {
        var element = tmp0_iterator.d1();
        // Inline function 'com.github.quillraven.fleks.World.system.<anonymous>' call
        if (element instanceof SnapshotSerializerSystem) {
          tmp$ret$0 = element;
          break $l$block;
        }
      }
      throw FleksNoSuchSystemException.o1x(getKClass(SnapshotSerializerSystem));
    }
    tmp$ret$0.zfu(fast);
    return Unit_instance;
  };
}
function GameScene$sceneInit$lambda_9(this$0) {
  return function (fast) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'com.github.quillraven.fleks.World.system' call
      // Inline function 'kotlin.collections.forEach' call
      var tmp0_iterator = _get_gameWorld__9fg7e7(this$0).o20().b1();
      while (tmp0_iterator.c1()) {
        var element = tmp0_iterator.d1();
        // Inline function 'com.github.quillraven.fleks.World.system.<anonymous>' call
        if (element instanceof SnapshotSerializerSystem) {
          tmp$ret$0 = element;
          break $l$block;
        }
      }
      throw FleksNoSuchSystemException.o1x(getKClass(SnapshotSerializerSystem));
    }
    tmp$ret$0.afv(fast);
    return Unit_instance;
  };
}
function GameScene$sceneInit$lambda_10(this$0, $$this$inGameMenuView) {
  return function (saveGameState) {
    var tmp;
    if (saveGameState) {
      var tmp$ret$0;
      $l$block: {
        // Inline function 'com.github.quillraven.fleks.World.system' call
        // Inline function 'kotlin.collections.forEach' call
        var tmp0_iterator = _get_gameWorld__9fg7e7(this$0).o20().b1();
        while (tmp0_iterator.c1()) {
          var element = tmp0_iterator.d1();
          // Inline function 'com.github.quillraven.fleks.World.system.<anonymous>' call
          if (element instanceof SnapshotSerializerSystem) {
            tmp$ret$0 = element;
            break $l$block;
          }
        }
        throw FleksNoSuchSystemException.o1x(getKClass(SnapshotSerializerSystem));
      }
      tmp$ret$0.kfu(_get_gameWorld__9fg7e7(this$0), $$this$inGameMenuView.lg6_1);
      tmp = Unit_instance;
    } else {
      var tmp$ret$1;
      $l$block_0: {
        // Inline function 'com.github.quillraven.fleks.World.system' call
        // Inline function 'kotlin.collections.forEach' call
        var tmp0_iterator_0 = _get_gameWorld__9fg7e7(this$0).o20().b1();
        while (tmp0_iterator_0.c1()) {
          var element_0 = tmp0_iterator_0.d1();
          // Inline function 'com.github.quillraven.fleks.World.system.<anonymous>' call
          if (element_0 instanceof SnapshotSerializerSystem) {
            tmp$ret$1 = element_0;
            break $l$block_0;
          }
        }
        throw FleksNoSuchSystemException.o1x(getKClass(SnapshotSerializerSystem));
      }
      tmp$ret$1.jfu(_get_gameWorld__9fg7e7(this$0), $$this$inGameMenuView.lg6_1);
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
function down$factory() {
  return getPropertyCallableRef('down', 1, KProperty1, function (receiver) {
    return receiver.dbf_1;
  }, null);
}
function move$factory() {
  return getPropertyCallableRef('move', 1, KProperty1, function (receiver) {
    return receiver.lbf_1;
  }, null);
}
function up$factory() {
  return getPropertyCallableRef('up', 1, KProperty1, function (receiver) {
    return receiver.gbf_1;
  }, null);
}
function handlePauseAction($this) {
  $this.qg6_1 = !$this.qg6_1;
  $this.mg6_1($this.qg6_1);
}
function InGameMenuView$onPauseAction$lambda(it) {
  return Unit_instance;
}
function InGameMenuView$onRewindAction$lambda(it) {
  return Unit_instance;
}
function InGameMenuView$onForwardAction$lambda(it) {
  return Unit_instance;
}
function InGameMenuView$onSaveGameAction$lambda(it) {
  return Unit_instance;
}
function InGameMenuView$pauseButton$lambda(this$0) {
  return function (it) {
    handlePauseAction(this$0);
    return Unit_instance;
  };
}
function InGameMenuView$pauseButton$lambda_0($handler) {
  return function (it) {
    $handler(it);
    return Unit_instance;
  };
}
function InGameMenuView$fastForwardButton$lambda(this$0) {
  return function () {
    this$0.og6_1(true);
    return Unit_instance;
  };
}
function InGameMenuView$forwardButton$lambda(this$0) {
  return function () {
    this$0.og6_1(false);
    return Unit_instance;
  };
}
function InGameMenuView$rewindButton$lambda(this$0) {
  return function () {
    this$0.ng6_1(false);
    return Unit_instance;
  };
}
function InGameMenuView$lambda(this$0) {
  return function () {
    this$0.ng6_1(true);
    return Unit_instance;
  };
}
function InGameMenuView$lambda_0(this$0) {
  return function (it) {
    handlePauseAction(this$0);
    return Unit_instance;
  };
}
function InGameMenuView$lambda_1(this$0) {
  return function (it) {
    this$0.ng6_1(true);
    return Unit_instance;
  };
}
function InGameMenuView$lambda_2(this$0) {
  return function (it) {
    this$0.ng6_1(false);
    return Unit_instance;
  };
}
function InGameMenuView$lambda_3(this$0) {
  return function (it) {
    this$0.og6_1(false);
    return Unit_instance;
  };
}
function InGameMenuView$lambda_4(this$0) {
  return function (it) {
    this$0.og6_1(true);
    return Unit_instance;
  };
}
function InGameMenuView$lambda_5(this$0) {
  return function (it) {
    this$0.pg6_1(false);
    return Unit_instance;
  };
}
function InGameMenuView$lambda_6(this$0) {
  return function (it) {
    this$0.pg6_1(true);
    return Unit_instance;
  };
}
function click$factory() {
  return getPropertyCallableRef('click', 1, KProperty1, function (receiver) {
    return receiver.abf_1;
  }, null);
}
function TouchButtonView$onPressed$lambda() {
  return Unit_instance;
}
function TouchButtonView$lambda($pressed) {
  return function ($this$addFixedUpdater) {
    if ($pressed._v)
      $this$addFixedUpdater.ug9_1();
    return Unit_instance;
  };
}
function TouchButtonView$lambda_0($pressed) {
  return function (it) {
    $pressed._v = true;
    return Unit_instance;
  };
}
function TouchButtonView$lambda_1($handler) {
  return function (it) {
    $handler(it);
    return Unit_instance;
  };
}
function TouchButtonView$lambda_2($pressed) {
  return function (it) {
    $pressed._v = false;
    return Unit_instance;
  };
}
function TouchButtonView$lambda_3($handler) {
  return function (it) {
    $handler(it);
    return Unit_instance;
  };
}
function TouchButtonView$lambda_4($pressed) {
  return function (it) {
    $pressed._v = false;
    return Unit_instance;
  };
}
function TouchButtonView$lambda_5($handler) {
  return function (it) {
    $handler(it);
    return Unit_instance;
  };
}
function down$factory_0() {
  return getPropertyCallableRef('down', 1, KProperty1, function (receiver) {
    return receiver.dbf_1;
  }, null);
}
function up$factory_0() {
  return getPropertyCallableRef('up', 1, KProperty1, function (receiver) {
    return receiver.gbf_1;
  }, null);
}
function out$factory() {
  return getPropertyCallableRef('out', 1, KProperty1, function (receiver) {
    return receiver.cbf_1;
  }, null);
}
function CollisionSystem$_init_$lambda_k5g4sq($this$family) {
  $this$family.a1z([Companion_getInstance_0(), Companion_getInstance_1()]);
  return Unit_instance;
}
//region block: post-declaration
initMetadataForLambda(main$slambda, VOID, VOID, [1]);
initMetadataForCompanion(Companion);
initMetadataForCompanion(Companion_0);
initMetadataForCompanion(Companion_1);
protoOf($serializer).e17 = typeParametersSerializers;
initMetadataForObject($serializer, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(GameStartConfig, 'GameStartConfig', VOID, VOID, [EntityConfig], VOID, VOID, {0: $serializer_getInstance});
initMetadataForCompanion(Companion_2);
protoOf($serializer_0).e17 = typeParametersSerializers;
initMetadataForObject($serializer_0, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(MeteoriteConfig, 'MeteoriteConfig', VOID, VOID, [EntityConfig], VOID, VOID, {0: $serializer_getInstance_0});
initMetadataForCompanion(Companion_3);
protoOf($serializer_1).e17 = typeParametersSerializers;
initMetadataForObject($serializer_1, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(MeteoriteTrailConfig, 'MeteoriteTrailConfig', VOID, VOID, [EntityConfig], VOID, VOID, {0: $serializer_getInstance_1});
initMetadataForCompanion(Companion_4);
protoOf($serializer_2).e17 = typeParametersSerializers;
initMetadataForObject($serializer_2, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(MeteoritesSpawnerConfig, 'MeteoritesSpawnerConfig', VOID, VOID, [EntityConfig], VOID, VOID, {0: $serializer_getInstance_2});
initMetadataForClass(GameScene, 'GameScene', VOID, VOID, VOID, [0]);
initMetadataForClass(InGameMenuView, 'InGameMenuView');
initMetadataForClass(TouchButtonView, 'TouchButtonView');
initMetadataForClass(CollisionSystem, 'CollisionSystem', CollisionSystem.fg7);
//endregion
//region block: init
Companion_instance_2 = new Companion_1();
Companion_instance_3 = new Companion_2();
Companion_instance_4 = new Companion_3();
Companion_instance_5 = new Companion_4();
//endregion
mainWrapper();
